import React from 'react';
import styled, {useTheme} from 'styled-components/native';
import {BottomSheetFlatList} from '@gorhom/bottom-sheet';
import {Theme} from '../../theme/lightTheme';
import {Space} from '../../screens/content/home';
import {FiltersSheetProps} from '../../interfaces/components/filtersSheet';
import {toggleSettingsModal} from '../../connected-components/settingsModal/actions';
import GenericButton from '../button';
import Animated, {FadeInDown} from 'react-native-reanimated';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {FilterItemType} from '../../interfaces/reducers/homeState';
import {isWeb} from '../../utils/responsive';
import {FlatList} from 'react-native-gesture-handler';
import useResponsiveDimensions from '../../utils/hooks/useResponsiveDimensions';

const Container = styled.View`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
const FilterItem = styled(GenericButton)<{selected?: boolean}>`
  width: 96%;
  align-self: center;
  border-radius: 100px;
  border-color: ${({theme}) => theme.settings.icon + '33'};
  border-width: ${({selected}) => (selected ? 0 : 1)}px;
  background-color: ${({theme, selected}) =>
    selected ? theme.primary : 'transparent'};
  margin-bottom: ${({theme}) => theme.text.s10}px;
`;

/**
 * FiltersSheet screen component.
 *
 * @param {FiltersSheetProps} props - The FiltersSheet component props.
 */
const FiltersSheet: React.FC<FiltersSheetProps> = ({
  onItemPress,
  filters,
  selectedFilterId,
}: FiltersSheetProps) => {
  const theme = useTheme() as Theme;
  const {bottom: bottomInset} = useSafeAreaInsets();
  const {isMobile} = useResponsiveDimensions();

  const onFilterItemPress = (item: FilterItemType) => {
    toggleSettingsModal();
    onItemPress?.(item);
  };

  const _renderItem = ({item}: {item: FilterItemType}) => {
    const isSelected = selectedFilterId === item?.id;
    return (
      <Animated.View entering={FadeInDown.delay(200)}>
        <FilterItem
          selected={isSelected}
          disabledNoOpacity={isSelected}
          label={item?.value || ''}
          labelStyle={{
            color: isSelected ? theme.button.text : theme.text.dark,
            padding: theme.text.s8,
            textAlign: 'center',
          }}
          dynamicHeight
          onPress={() => onFilterItemPress(item)}
          radius={100}
        />
      </Animated.View>
    );
  };

  const _renderFooter = () => {
    return <Space bottomInset={bottomInset} />;
  };

  const BottomSheetFlatListComponent =
    isWeb && !isMobile ? FlatList : BottomSheetFlatList;

  return (
    <Container>
      <BottomSheetFlatListComponent
        data={filters}
        renderItem={_renderItem}
        contentContainerStyle={{
          paddingTop: '5%',
          width: '100%',
          flexGrow: 1,
        }}
        style={{
          width: '100%',
          flexGrow: 1,
        }}
        ListFooterComponent={_renderFooter}
      />
    </Container>
  );
};

export default FiltersSheet;
